module.exports = __webpack_public_path__ + "static/media/01_1.aca31624.png";